import React from 'react';
import TechTaskProgressBar from '@/pages/ipe/workbench/components/TechTaskProgressBar';
import {
  computeStudioCropPercent,
  formatStudioProgressLines,
} from '../utils/imageCropStudioProgress';
import '@/styles/ipe/workbench/components/TechTaskProgressBar.css';

/**
 * T3-3.1 Studio 页进度：上传 N/30、识别批次、裁剪 success/total + failed。
 */
export default function ImageCropStudioProgressBar({ progress }) {
  if (!progress?.active) return null;

  const lines = formatStudioProgressLines(progress);
  const percent = computeStudioCropPercent(progress);
  const variant = progress.phase === 'upload' ? 'processing' : 'processing';

  return (
    <div className="image-crop-studio-progress" aria-live="polite">
      <TechTaskProgressBar percent={percent} variant={variant} />
      <ul className="image-crop-studio-progress__lines">
        {lines.map((line) => (
          <li key={line.key} className="image-crop-studio-progress__line">
            <span className="image-crop-studio-progress__label">{line.label}</span>
            <span className="image-crop-studio-progress__value">{line.value}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
